import axios from "axios";
import { baseURL } from "../constants/baseUrl";

const appApi = axios.create({
  baseURL: baseURL,
  // baseURL: "https://api.v2.rahebehesht.com",
});
appApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("UserToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default appApi;
